(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('crypto-js')) :
  typeof define === 'function' && define.amd ? define(['crypto-js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global["sign-utils"] = factory(global.CryptoJS));
})(this, (function (CryptoJS) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var CryptoJS__default = /*#__PURE__*/_interopDefaultLegacy(CryptoJS);

  const secretKeyKey = 'key';
  const genSign=(signData = {},signSecretKey)=> {
    const data = { ...signData };
    // 为空的参数不参与point计算
     Object.keys(data).forEach(item=>{
         if(data[item]==='')
         {delete data[item];}
     });
    const keySortArr = Object.keys(data)
      .sort()
      .filter((v) => !(data[v] === undefined));  // 遍历所有参数，将参数与参数值按照param + "=" + value + "&" 拼接，然后按照字母序排序，过滤掉参数值为空的和sign参数排序后依次拼接
    keySortArr.push(secretKeyKey);
    data[secretKeyKey] = signSecretKey;  // 最后拼接上"key=" + 密钥
    const sign = `${keySortArr.map((k) => `${k}=${data[k]}`).join('&')}`;
    return [CryptoJS__default["default"].MD5(sign).toString(CryptoJS__default["default"].enc.Hex), keySortArr.join(',')] //然后对这个字符串进行MD5
  };
  /**
   * v3版本的加解密工具函数
   *
   * @param {Object} requestData 请求的参数
   * @param {string} signSecretKey secretkey需找服务端获取
   * @param {number} keyId keyid找对应服务端获取
   * @param {string} product 产品名
   * @param {string} keyfrom 来源
   * @return {Object} 返回值描述
   */
  // 包括11个通用接口必填参数https://confluence.inner.youdao.com/pages/viewpage.action?pageId=11539267
  // 1.1.1 版本改动
  // 1、传参添加签名参数，可以传入真实的参数值
  // 2、signData 的合并方法将 requestData 后置，如果有签名参数则覆盖写死的值
  const genParamV3=(
    requestData,
    signSecretKey,
    keyId,
    product,
    keyfrom,
    appVersion = 1,
    client = 'web',
    mid = 1,
    vendor = 'web',
    screen = 1,
    model = 1,
    imei = 1,
    network = 'wifi',
    yduuid = 'abcdefg'
  ) => {
    // 判断是否是formdata
    const isFormdata = requestData instanceof FormData;
    // 如果是formdata，则将参数转换成普通对象进行加密
    requestData = isFormdata ? Object.fromEntries(requestData.entries()) : requestData;
    const signData = Object.assign({
      product,
      appVersion, // 产品版本
      client, // 客户端
      mid, //系统版本
      vendor, //安装渠道
      screen, // 设备屏幕
      model, // 设备型号
      imei, // 设备国际移动设备识别码
      network, // 网络
      keyfrom, // 访问来源
      keyid: keyId,
      mysticTime: Date.now(),
      yduuid
    }, requestData);
    const [sign, pointParam] = genSign(signData,signSecretKey);
    Object.assign(signData, {
      sign,
      pointParam,
    });
    // 如果是传入是formdata，则返回加密后的formdata参数
    if (isFormdata) {
      const fd = new FormData();
      for(let key in signData) {
        fd.append(key, signData[key]);
      }
      return fd
    }
    return signData
  };
  var index = {
    genSign,
    genParamV3
  };

  return index;

}));
